import {createAsyncThunk} from "@reduxjs/toolkit";
import {handlerError} from "../../../store/handleError";
import {mlMonitorAPI} from "../api";
import {IMLStatusResponse} from "../../../models/IMLMonitor";

export const fetchMLStatus = createAsyncThunk<
    IMLStatusResponse,
    void,
    { rejectValue: string }
>(
    "ml_monitor/fetchStatus",
    async (_, {rejectWithValue, signal}) => {
        try {
            return await mlMonitorAPI.getStatus(signal);
        } catch (e: unknown) {
            if (e instanceof DOMException && e.name === "AbortError") throw e;
            return rejectWithValue(handlerError(e));
        }
    },
);

export const markPredictionRead = createAsyncThunk<
    string,
    string,
    { rejectValue: string }
>(
    "ml_monitor/markRead",
    async (predictionId, {rejectWithValue}) => {
        try {
            await mlMonitorAPI.markRead(predictionId);
            return predictionId;
        } catch (e: unknown) {
            return rejectWithValue(handlerError(e));
        }
    },
);
